import { useMemo } from 'react';
import { Box, IconButton } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { TFunction } from 'i18next';

import { DataTableColumn } from '@/components/datatable/NewWcnTable';
import { UserApiResponse } from '@/services/userService';
import { getUserFullName } from '../utils/userUtils';

interface UseUserColumnsProps {
    t: TFunction;
    canEdit: (user: UserApiResponse) => boolean;
    onEdit: (user: UserApiResponse) => void;
    onDelete: (user: UserApiResponse) => void;
}

export const useUserColumns = ({
    t,
    canEdit,
    onEdit,
    onDelete
}: UseUserColumnsProps): DataTableColumn<UserApiResponse>[] =>
    useMemo(
        () => [
            {
                text: t('name'),
                value: 'givenName',
                width: 300,
                render: (row) => <Box sx={{ overflowY: 'auto' }}>{getUserFullName(row)}</Box>
            },
            {
                text: t('mailAddress'),
                value: 'eMail',
                width: 300
            },
            {
                text: t('role'),
                value: 'role',
                width: 200
            },
            {
                text: t('actions'),
                value: 'actions',
                sortable: false,
                isAction: true,
                width: 100,
                render: (row) => {
                    const editEnabled = canEdit(row);

                    return (
                        <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                            <IconButton
                                size="small"
                                disabled={!editEnabled}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEdit(row);
                                }}
                            >
                                <Edit fontSize="small" />
                            </IconButton>
                            <IconButton
                                size="small"
                                disabled={!editEnabled}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete(row);
                                }}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Box>
                    );
                }
            }
        ],
        [t, canEdit, onEdit, onDelete]
    );
